import React from "react";
import Vote from "../../pageInside/commentaire/vote";
import { UserVoteCount } from "../../pageInside/commentaire/userVoteCount";
import { elakayAutoText, elakayPluralText } from "../../pageInside/dataElakay";
import "./GlobalRatingBadge.css";

// Global Provider Product rating (ticket §2/§3): stars + average + total count, visible on the
// card without opening the product. Reuses the SAME star component Seller/User Royale product
// cards already use (pageInside/commentaire/vote.js's <Vote>, read-only here -- no productID/
// clickShow means it never becomes an interactive voting control) -- no second rating system.
// `ratings` is the { globalRating, totalRatings } shape returned by
// dropshippingInterne/services/providerProductRatings.js (server_elakay), already aggregated
// across every Seller Product linked to this Provider Product -- never computed here.
export default function GlobalRatingBadge({ ratings, size = "16px" }) {
  const total = Number(ratings?.totalRatings) || 0;
  if (total <= 0) {
    // <Vote>/react-star-ratings renders <div>s internally -- a <p> wrapper (like ShowImage.js's
    // OWN read-only vote display uses <div>, never <p>) would be invalid HTML nesting.
    return <div className="global-rating-badge global-rating-badge--empty" aria-label={elakayAutoText("h_gpr_none", "No ratings yet")}>{elakayAutoText("h_gpr_none", "No ratings yet")}</div>;
  }
  const average = Math.max(0, Math.min(5, Number(ratings?.globalRating) || 0));
  return (
    <div className="global-rating-badge" data-testid="global-rating-badge" aria-label={elakayPluralText(total, ["h_gpr_aria_one", "Rated {value0} out of 5 from {value1} rating"], ["h_gpr_aria", "Rated {value0} out of 5 from {value1} ratings"], { value0: average.toFixed(1), value1: total })}>
      <Vote rating={average} starSize={size} />
      <span className="global-rating-badge__count">{average.toFixed(1)} ({UserVoteCount(total)})</span>
    </div>
  );
}
